// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotCommandRenderer__link-a2f7db {
  cursor: pointer;
  color: var(--brand-primary-40);
  user-select: all;
  text-decoration: none;
}

.BotCommandRenderer__link-a2f7db:hover,
.BotCommandRenderer__link-a2f7db:active {
  text-decoration: underline;
}

.BotCommandRenderer__link-a2f7db:focus-visible {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/TextRenderer/renderTree/BotCommandRenderer/BotCommandRenderer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF","sourcesContent":[".link {\n  cursor: pointer;\n  color: var(--brand-primary-40);\n  user-select: all;\n  text-decoration: none;\n}\n\n.link:hover,\n.link:active {\n  text-decoration: underline;\n}\n\n.link:focus-visible {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `BotCommandRenderer__link-a2f7db`
};
module.exports = ___CSS_LOADER_EXPORT___;
